// extracted by mini-css-extract-plugin
export default {"buttonV2":"ButtonV2_buttonV2__E3A70","fill":"ButtonV2_fill__cR+25","danger":"ButtonV2_danger__Dg6lt","md":"ButtonV2_md__B90wZ","xs":"ButtonV2_xs__0l7wy"};